































import Component from 'vue-class-component';
import { Vue, Prop } from 'vue-property-decorator';
import axios from "axios";
import Constants from '../constants';
import Swal from 'sweetalert2';
import { EventBus } from '@/event-bus';

@Component({
    props: ['url', 'fileTypeName', 'files', 'cols', 'labelCols', 'isShow', 'isLabelHide', 'buttonLabel', 'billNumber', 'buttonText']
})
export default class DownloadInput extends Vue {
    @Prop()
    url: any;
    @Prop()
    fileTypeName: any;
    @Prop()
    labelCols :any;    
    @Prop()
    files: any;
    @Prop()
    isLabelHide: any;
    @Prop()
    buttonLabel: any;
    @Prop()
    billNumber: any;

    lCols: any = this.labelCols ? this.labelCols : 2;
    inProgress: any = false;

    generate() {
      if(this.url)
      {        
        this.inProgress = true;  

        axios.get(this.url).then((response) => {
          EventBus.$emit('success', { msg: this.$t('Файл создан') });
          this.$emit('generated');
        })
        .catch((e) => {
          var message = e.status == 401 ? this.$t('Время сессии истекло. Обновите страницу') : e.data.message;              
          Swal(this.$t('Ошибка') + '', message, 'warning');
        })
        .finally(() => { this.inProgress = false; });   
      } else {
          this.$emit('clicked');
      }  
    }

    get shrinkedFileName() {
      if(this.file && this.file.name)
      {
        return (this.file.name.length > 13) ? this.file.name.substr(0, 13 - 1) + '...' : this.file.name;
      }
    }

    get file() {
      if(this.billNumber){
        return this.files.find((f: any) => f.fileTypeName == this.fileTypeName && f.name.includes(`Счет_№${this.billNumber}`));
      } else {
        return this.files.find((f: any) => f.fileTypeName == this.fileTypeName);
      }      
    }

    get downloadUrl() {
        if(this.file)
        {
            return Constants.baseUrl + "/file/" + this.file.id;
        }   
        
        return '';
    }
}
